import React from 'react';

const FeaturedPromos: React.FC = () => {
  return (
    <section className="px-3 pt-4 pb-2">
      <div className="grid grid-cols-2 gap-3">
        {/* TipClub Card */}
        <div className="bg-white rounded-2xl p-4 shadow-sm overflow-hidden relative">
          <h3 className="text-lg font-black text-gray-900 mb-0.5">TipClub</h3>
          <p className="text-[11px] text-gray-500 mb-3">134,9k Scheine, 60,7k Nutzer</p>
          <div className="flex items-center gap-2 bg-gray-50 rounded-xl px-3 py-2">
            <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden flex-shrink-0 flex items-center justify-center text-lg">
              🎯
            </div>
            <div>
              <p className="text-[11px] text-gray-500">2er Kombi</p>
              <p className="text-sm font-black text-gray-900">10,20 Quote</p>
            </div>
          </div>
        </div>

        {/* Million Card */}
        <div className="bg-white rounded-2xl p-4 shadow-sm overflow-hidden relative">
          <div className="absolute top-3 right-3 bg-red-600 text-white px-2 py-0.5 rounded-full text-[10px] font-bold">
            NEUE
          </div>
          <h3 className="text-lg font-black text-gray-900 mb-0.5">Million</h3>
          <p className="text-[11px] text-gray-500 mb-3">12k+ Gewinner!</p>
          <div className="flex items-center gap-2 bg-red-50 rounded-xl px-3 py-2">
            <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xs font-black">1M</span>
            </div>
            <div>
              <p className="text-[11px] text-gray-500">7 Tipps für</p>
              <p className="text-sm font-black text-gray-900">2.500.000 €</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPromos;
